export default __webpack_public_path__ + "static/media/empl_indirect_direct.952bd9c5.svg";